// Map field names to their corresponding icon paths
const ICON_BASE_URL = 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/icons';

export const getFieldIcon = (fieldName: string): string | undefined => {
  const iconMap: Record<string, string> = {
    'address': `${ICON_BASE_URL}/address-home.png`,
    'bedrooms': `${ICON_BASE_URL}/bedroom.png`,
    'bathrooms': `${ICON_BASE_URL}/bathroom.png`,
    'livingArea': `${ICON_BASE_URL}/area.png`,
    'area': `${ICON_BASE_URL}/area.png`,
    'commercialAddress': `${ICON_BASE_URL}/commercial-address.png`,
    'timeSlot': `${ICON_BASE_URL}/time-slot-clock.png`,
    'date': `${ICON_BASE_URL}/date-calendar.png`,
    'startDate': `${ICON_BASE_URL}/date-calendar.png`,
    'kitchen': `${ICON_BASE_URL}/kitchen.png`,
    'crewcount': `${ICON_BASE_URL}/crewcount.png`,
    'duration': `${ICON_BASE_URL}/duration.png`,
    'frequency': `${ICON_BASE_URL}/frequency.png`,
    'glasses-only': `${ICON_BASE_URL}/glass-clean.png`,
    'is-duplex': `${ICON_BASE_URL}/duplex.png`,
  };

  // Try exact match first
  if (iconMap[fieldName]) {
    return iconMap[fieldName];
  }

  // Try case-insensitive match
  const lowerFieldName = fieldName.toLowerCase();
  for (const [key, value] of Object.entries(iconMap)) {
    if (key.toLowerCase() === lowerFieldName) {
      return value;
    }
  }

  // Try partial match for common patterns
  if (lowerFieldName.includes('address')) {
    return lowerFieldName.includes('commercial') 
      ? `${ICON_BASE_URL}/commercial-address.png` 
      : `${ICON_BASE_URL}/address-home.png`;
  }
  if (lowerFieldName.includes('bedroom')) return `${ICON_BASE_URL}/bedroom.png`;
  if (lowerFieldName.includes('bathroom')) return `${ICON_BASE_URL}/bathroom.png`;
  if (lowerFieldName.includes('area')) return `${ICON_BASE_URL}/area.png`;
  if (lowerFieldName.includes('time') || lowerFieldName.includes('slot')) {
    return `${ICON_BASE_URL}/time-slot-clock.png`;
  }
  if (lowerFieldName.includes('date') || lowerFieldName.includes('calendar')) {
    return `${ICON_BASE_URL}/date-calendar.png`;
  }

  return undefined;
};
